// page-products ページのjs
import Swiper from "swiper";
import { Pagination, Autoplay } from "swiper/modules";

// eslint-disable-next-line import/no-unresolved
import "swiper/css/bundle";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/pagination";

// eslint-disable-next-line no-unused-vars
export const swiper = new Swiper(".swiper", {
  modules: [Pagination, Autoplay],
  loop: true,
  slidesPerView: 1,
  speed: 1000,
  autoplay: {
    delay: 5000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
export default swiper;
